import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderReports: build.query<
      GetV2ProviderReportsApiResponse,
      GetV2ProviderReportsApiArg
    >({
      query: () => ({ url: `/v2/provider/reports` }),
    }),
    getV2ProviderReportsAccessMatrix: build.query<
      GetV2ProviderReportsAccessMatrixApiResponse,
      GetV2ProviderReportsAccessMatrixApiArg
    >({
      query: () => ({ url: `/v2/provider/reports/access-matrix` }),
    }),
    patchV2ProviderReportsAccessMatrix: build.mutation<
      PatchV2ProviderReportsAccessMatrixApiResponse,
      PatchV2ProviderReportsAccessMatrixApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/access-matrix`,
        method: "PATCH",
        body: queryArg.updateReportAccessRequest,
      }),
    }),
    getV2ProviderReportsCompensationConfig: build.query<
      GetV2ProviderReportsCompensationConfigApiResponse,
      GetV2ProviderReportsCompensationConfigApiArg
    >({
      query: () => ({ url: `/v2/provider/reports/compensation-config` }),
    }),
    putV2ProviderReportsCompensationConfig: build.mutation<
      PutV2ProviderReportsCompensationConfigApiResponse,
      PutV2ProviderReportsCompensationConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/compensation-config`,
        method: "PUT",
        body: queryArg.compensationConfig,
      }),
    }),
    getV2ProviderReportsRecentRuns: build.query<
      GetV2ProviderReportsRecentRunsApiResponse,
      GetV2ProviderReportsRecentRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/recent-runs`,
        params: {
          limit: queryArg.limit,
        },
      }),
    }),
    getV2ProviderReportsSavedViews: build.query<
      GetV2ProviderReportsSavedViewsApiResponse,
      GetV2ProviderReportsSavedViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/saved-views`,
        params: {
          report_key: queryArg.reportKey,
        },
      }),
    }),
    postV2ProviderReportsSavedViews: build.mutation<
      PostV2ProviderReportsSavedViewsApiResponse,
      PostV2ProviderReportsSavedViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/saved-views`,
        method: "POST",
        body: queryArg.createSavedReportViewRequest,
      }),
    }),
    deleteV2ProviderReportsSavedViewsByViewId: build.mutation<
      DeleteV2ProviderReportsSavedViewsByViewIdApiResponse,
      DeleteV2ProviderReportsSavedViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/saved-views/${queryArg.viewId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderReportsByReportKeyExport: build.query<
      GetV2ProviderReportsByReportKeyExportApiResponse,
      GetV2ProviderReportsByReportKeyExportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/${queryArg.reportKey}/export`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          basis: queryArg.basis,
          group_by: queryArg.groupBy,
          columns: queryArg.columns,
          compare: queryArg.compare,
          sort: queryArg.sort,
          sort_dir: queryArg.sortDir,
          filters: queryArg.filters,
          format: queryArg.format,
          csv_profile: queryArg.csvProfile,
          sheet_by: queryArg.sheetBy,
          tz: queryArg.tz,
        },
      }),
    }),
    getV2ProviderReportsByReportKeyRun: build.query<
      GetV2ProviderReportsByReportKeyRunApiResponse,
      GetV2ProviderReportsByReportKeyRunApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/reports/${queryArg.reportKey}/run`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          basis: queryArg.basis,
          group_by: queryArg.groupBy,
          columns: queryArg.columns,
          compare: queryArg.compare,
          sort: queryArg.sort,
          sort_dir: queryArg.sortDir,
          filters: queryArg.filters,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderReportsApiResponse =
  /** status 200 OK */ ReportListResponse;
export type GetV2ProviderReportsApiArg = void;
export type GetV2ProviderReportsAccessMatrixApiResponse =
  /** status 200 OK */ ReportAccessMatrixResponse;
export type GetV2ProviderReportsAccessMatrixApiArg = void;
export type PatchV2ProviderReportsAccessMatrixApiResponse =
  /** status 200 OK */ ReportAccessMatrixResponse;
export type PatchV2ProviderReportsAccessMatrixApiArg = {
  updateReportAccessRequest: UpdateReportAccessRequest;
};
export type GetV2ProviderReportsCompensationConfigApiResponse =
  /** status 200 OK */ CompensationConfig;
export type GetV2ProviderReportsCompensationConfigApiArg = void;
export type PutV2ProviderReportsCompensationConfigApiResponse =
  /** status 200 OK */ CompensationConfig;
export type PutV2ProviderReportsCompensationConfigApiArg = {
  compensationConfig: CompensationConfig;
};
export type GetV2ProviderReportsRecentRunsApiResponse =
  /** status 200 OK */ RecentRunsResponse;
export type GetV2ProviderReportsRecentRunsApiArg = {
  /** Max distinct recent runs */
  limit?: number;
};
export type GetV2ProviderReportsSavedViewsApiResponse =
  /** status 200 OK */ SavedReportViewListResponse;
export type GetV2ProviderReportsSavedViewsApiArg = {
  /** Filter by report key */
  reportKey?: string | null;
};
export type PostV2ProviderReportsSavedViewsApiResponse =
  /** status 200 OK */ SavedReportViewSchema2;
export type PostV2ProviderReportsSavedViewsApiArg = {
  createSavedReportViewRequest: CreateSavedReportViewRequest;
};
export type DeleteV2ProviderReportsSavedViewsByViewIdApiResponse =
  /** status 200 OK */ DeleteSavedReportViewResponse;
export type DeleteV2ProviderReportsSavedViewsByViewIdApiArg = {
  viewId: string;
};
export type GetV2ProviderReportsByReportKeyExportApiResponse = unknown;
export type GetV2ProviderReportsByReportKeyExportApiArg = {
  reportKey: string;
  /** Window start (inclusive, org-local) */
  startDate: string;
  /** Window end (inclusive, org-local) */
  endDate: string;
  /** Date basis, e.g. service_date or payment_posted */
  basis?: string | null;
  /** Comma-separated dimension keys (0-2); empty = one group */
  groupBy?: string | null;
  /** Comma-separated detail column keys to include */
  columns?: string | null;
  /** Set to prior_period for stat deltas vs the same-length window immediately preceding */
  compare?: string | null;
  /** Detail column key to sort rows by within each group; band order is unaffected */
  sort?: string | null;
  /** Sort direction: asc (default) or desc */
  sortDir?: string | null;
  /** URL-encoded JSON array of row filters, e.g. [{"field":"payer_class","op":"any_of","values":["Medicaid"]}]. Fields must be filterable columns; ops derive from column type (string: is/is_not/any_of · numeric: eq/gt/gte/lt/lte · date: before/after · bool: is · all: is_empty/not_empty); max 5, AND semantics */
  filters?: string | null;
  /** Export format: csv (default), xlsx, or pdf */
  format?: string | null;
  /** Definition-owned downstream CSV layout key. Only valid for CSV exports. */
  csvProfile?: string | null;
  /** Dimension key to split detail rows by: one sheet per value for xlsx, one page per value for pdf (e.g. clinician for a per-clinician day sheet) */
  sheetBy?: string | null;
  /** IANA timezone for rendered datetimes (pdf only), e.g. America/New_York; datetimes render in UTC without it */
  tz?: string | null;
};
export type GetV2ProviderReportsByReportKeyRunApiResponse =
  /** status 200 OK */ RunReportResponse;
export type GetV2ProviderReportsByReportKeyRunApiArg = {
  reportKey: string;
  /** Window start (inclusive, org-local) */
  startDate: string;
  /** Window end (inclusive, org-local) */
  endDate: string;
  /** Date basis, e.g. service_date or payment_posted */
  basis?: string | null;
  /** Comma-separated dimension keys (0-2); empty = one group */
  groupBy?: string | null;
  /** Comma-separated detail column keys to include */
  columns?: string | null;
  /** Set to prior_period for stat deltas vs the same-length window immediately preceding */
  compare?: string | null;
  /** Detail column key to sort rows by within each group; band order is unaffected */
  sort?: string | null;
  /** Sort direction: asc (default) or desc */
  sortDir?: string | null;
  /** URL-encoded JSON array of row filters, e.g. [{"field":"payer_class","op":"any_of","values":["Medicaid"]}]. Fields must be filterable columns; ops derive from column type (string: is/is_not/any_of · numeric: eq/gt/gte/lt/lte · date: before/after · bool: is · all: is_empty/not_empty); max 5, AND semantics */
  filters?: string | null;
};
export type ReportCsvExportProfileSchema = {
  description?: string | null;
  key: string;
  label: string;
};
export type ReportColumnSchema = {
  fill?: boolean;
  filterable?: boolean;
  group: string;
  key: string;
  label: string;
  type: string;
};
export type ReportDimensionSchema = {
  key: string;
  label: string;
  splittable?: boolean;
};
export type ReportMeasureSchema = {
  agg: string;
  key: string;
  label: string;
  source_key?: string | null;
  type: string;
};
export type ReportStatCardSchema = {
  emphasis?: string | null;
  format: string;
  key: string;
  label: string;
  measure_key: string;
  wants_delta: boolean;
};
export type ReportDefinitionSchema = {
  caveats: string[];
  csv_export_profiles?: ReportCsvExportProfileSchema[];
  default_columns: string[];
  default_window_days?: number;
  description: string;
  detail_columns: ReportColumnSchema[];
  dimensions: ReportDimensionSchema[];
  forward_window?: boolean;
  key: string;
  last_run_at?: string | null;
  measures: ReportMeasureSchema[];
  run_count_30d?: number;
  stat_cards: ReportStatCardSchema[];
  supported_bases: string[];
  title: string;
  uses_date_window?: boolean;
};
export type ReportListResponse = {
  reports: ReportDefinitionSchema[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ReportAccessCellSchema = {
  default_enabled: boolean;
  enabled: boolean;
  implied_by_manage_reports: boolean;
  label: string;
  overridden: boolean;
  role: string;
  /** Row scope for this cell: 'all' (the whole organization) or 'own' (only rows the viewer is attributed on). Always 'all' on a row that is not scopable and on a cell MANAGE_REPORTS implies. */
  scope?: "all" | "own";
};
export type ReportAccessRowSchema = {
  description: string;
  report_key: string;
  roles: ReportAccessCellSchema[];
  /** Whether this report can hold an 'own' scope. False means the report attributes no row to a viewer, so no scope control is offered on any of its cells. */
  scopable?: boolean;
  title: string;
};
export type ReportAccessMatrixResponse = {
  reports: ReportAccessRowSchema[];
};
export type UpdateReportAccessRequest = {
  enabled: boolean;
  report_key: string;
  role: string;
  /** Row scope to store for this cell: 'all' or 'own'. Omit to leave the stored scope untouched. 'own' is rejected with 400 on a report that declares no viewer scope field, and on a role that already holds MANAGE_REPORTS; disabling the cell clears its scope regardless of this value. */
  scope?: ("all" | "own") | null;
};
export type ClinicianRateOverride = {
  pct_bps: number;
  /** Rendering clinician's user id. */
  user_id: string;
};
export type ProviderRateClass =
  | "PHYSICIAN"
  | "PSYCHOLOGIST"
  | "CLINICAL_SOCIAL_WORKER"
  | "COUNSELOR"
  | "MFT"
  | "NPP"
  | "RN"
  | "SUD_COUNSELOR"
  | "ABA"
  | "PASTORAL"
  | "PSYCH_ASSOC"
  | "OTHER";
export type RateGroup = {
  /** Stable identifier for the group. */
  key: string;
  /** Display name, e.g. 'Licensed' / 'Associate'. */
  name: string;
  /** Commission rate in basis points (7000 = 70.00%). */
  pct_bps: number;
  /** Match only pre-licensed (True) / fully-licensed (False); None = either. */
  pre_licensed?: boolean | null;
  /** Billing rate classes this group matches; empty = any. */
  rate_classes?: ProviderRateClass[];
};
export type CompensationConfig = {
  overrides?: ClinicianRateOverride[];
  rate_groups?: RateGroup[];
};
export type RecentRunSchema = {
  params: {
    [key: string]: any;
  };
  ran_at?: string | null;
  report_key: string;
  title: string;
};
export type RecentRunsResponse = {
  runs: RecentRunSchema[];
};
export type SavedReportViewSchema = {
  created_at?: string | null;
  created_by: string;
  name: string;
  params: {
    [key: string]: any;
  };
  report_key: string;
  report_saved_view_id: string;
};
export type SavedReportViewListResponse = {
  views: SavedReportViewSchema[];
};
export type SavedReportViewSchema2 = {
  created_at?: string | null;
  created_by: string;
  name: string;
  params: {
    [key: string]: any;
  };
  report_key: string;
  report_saved_view_id: string;
};
export type CreateSavedReportViewRequest = {
  name: string;
  params?: {
    [key: string]: any;
  };
  report_key: string;
};
export type DeleteSavedReportViewResponse = {
  deleted: boolean;
};
export type ReportColumnSchema2 = {
  fill?: boolean;
  filterable?: boolean;
  group: string;
  key: string;
  label: string;
  type: string;
};
export type ReportSubgroupSchema = {
  aggregates: {
    [key: string]: any;
  };
  key: string;
  label?: string | null;
  row_count: number;
  rows: {
    [key: string]: any;
  }[];
};
export type ReportGroupSchema = {
  aggregates: {
    [key: string]: any;
  };
  key: string;
  label?: string | null;
  row_count: number;
  rows: {
    [key: string]: any;
  }[];
  subgroups?: ReportSubgroupSchema[] | null;
};
export type ReportStatSchema = {
  delta_pct?: number | null;
  emphasis?: string | null;
  format: string;
  key: string;
  label: string;
  value: any;
};
export type ReportTotalsSchema = {
  aggregates: {
    [key: string]: any;
  };
  row_count: number;
};
export type RunReportResponse = {
  basis: string;
  caveats: string[];
  columns: ReportColumnSchema2[];
  compare?: string | null;
  end_date: string;
  generated_at: string;
  group_by: string[];
  groups: ReportGroupSchema[];
  report_key: string;
  /** Row scope this run executed under. 'own' means every returned row is attributed to the caller, so the page can lock its clinician filter and drop clinician grouping. */
  scope?: "all" | "own";
  start_date: string;
  stats: ReportStatSchema[];
  totals: ReportTotalsSchema;
};
